<template>
  <div>
    <activity-modal :roleType="0" :rowId="rowId" />
  </div>
</template>

<script>
import ActivityModal from './../../components/ActivityModal';
export default {
  props: {
    rowId: {
      type: String,
      default: '',
    },
  },
  components: {
    ActivityModal,
  }
}
</script>

<style lang="scss" scoped>
</style>